import type { Location } from 'modules/core/lib/navigation/types'

export const navigation = {
  path: 'invoices',
  size: 'full',
  children: {
    list: {
      path: 'list',
      size: 'full',
      children: {
        exporter: {
          path: 'exporter',
          size: 'full',
        },
        invoiceId: {
          path: ':invoiceId',
          size: 'full',
          children: {
            reconciliations: {
              path: 'reconciliations',
              size: 'full',
            },
          },
        },
      },
    },
    inbox: {
      path: 'inbox',
      size: 'full',
      children: {
        messageId: {
          path: ':messageId',
          size: 'full',
        },
      },
    },
    sale_invoices: {
      path: 'sale_invoices',
      size: 'full',
      children: {
        detail: {
          path: 'detail/:invoiceId',
          size: 'full',
          children: {
            documents: {
              size: 'full',
              path: 'documents',
            },
            overview: {
              size: 'full',
              path: 'overview',
            },
            form: {
              path: 'form',
              size: 'full',
            },
          },
        },
        create: {
          path: 'create',
          size: 'full',
        },
        invoiceId: {
          path: ':invoiceId',
          size: 'full',
        },
        exporter: {
          path: 'exporter',
          size: 'full',
        },
      },
    },
  },
} as const satisfies Location
